import { ContractView } from './types/contractTypes';

export const createDefaultContract = (): ContractView => {
  return {
    id: '',
    company: '',
    payer: '',
    product: '',
    financialClass: 'Unknown',
    calcType: 'Unknown',
    facilityType: 'Both',
    effectiveDate: null,
    endDate: null,
    medicareBasedConfig: {
      basedOnMedicare: false,
      percentOfMedicare: 0,
      percentOfMedicareIP: 0,
      percentOfMedicareOP: 0,
      inpatientConversionFactor: 0,
      outpatientConversionFactor: 0,
      medicareContractId: '',
    },
    centers: [],
    drgFeeSchedules: [],
    cptFeeSchedules: [],
    multipliers: {
      cpt1: 100,
      cpt2: 100,
      cpt3: 100,
      cpt4: 100,
      cpt5: 100,
      cpt6: 100,
      cpt7: 100,
      cpt8: 100,
    },
    unspecified: {
      flatRate: null,
      percentBilled: null,
      maxRate: null,
    },
    implants: {
      percentOfCost: 0,
      thresholdType: 'NA',
      thresholdAmount: null,
    },
  };
};
